<template>
  <div
    v-if="contents && contents.length > 0"
    :class="['billboard-container', variant]"
    :data-entry-id="id"
  >
    <UiBillboard
      v-bind="billboardAttrs"
      @modal-opened="onTncOpened"
      @banner-impression="onTrackingImpression"
      @banner-clicked="onBannerClicked"
      @arrow-clicked="onArrowClicked"
    />
  </div>
</template>

<script lang="ts" setup>
import UiBillboard, { type PropsBillboard } from '@sephora-asia/ui-billboard'
import type { BillboardContainerProps } from '~/types/components/contentful/components.types'
import { usePageMetaStore } from '~/stores/page-meta-store'
import { BillboardVariantEnum } from '~/types/api/bff/web/contentful/component.types'

const props = defineProps<BillboardContainerProps>()

const { isMobile } = useDevice()
const { trackEvent } = useGtmTrack()
const pageMetaStore = usePageMetaStore()

const billboardAttrs = computed((): PropsBillboard => {
  return {
    ...props,
    isMobile,
    isInfinite: props.variant !== BillboardVariantEnum.MULTI,
  }
})

function onTncOpened(internalName: string, index: number) {
  trackEvent({
    event: 'lp_billboard_banner_tc_click',
    params: {
      billboard_name: internalName,
      billboard_position: index + 1,
      campaign_name: pageMetaStore.campaignName ?? '',
      page_path: useRoute().path,
    },
  })
}

function onBannerTrackingEvent(
  event: string,
  internalName: string,
  index: number
) {
  const banner = props.contents?.[index]

  trackEvent({
    event: `${pageMetaStore.pageType}_billboard_banner_${event}`,
    params: {
      billboard_name: internalName,
      billboard_position: index + 1,
      billboard_type:
        props.variant === BillboardVariantEnum.MULTI ? 'Multi' : 'Single',
      content_banner_position: props.componentPosition,
      campaign_name: pageMetaStore.campaignName ?? '',
      page_path: useRoute().path,
      segmented: banner?.isSegmented,
      segments: banner?.segments?.join(', '),
    },
  })
}

function onBannerClicked(internalName: string, index: number) {
  onBannerTrackingEvent('click', internalName, index)
}

function onTrackingImpression(internalName: string, index: number) {
  onBannerTrackingEvent('impression', internalName, index)
}

function onArrowClicked(internalName: string, index: number) {
  trackEvent({
    event: 'lp_billboard_banner_next_click',
    params: {
      billboard_name: internalName,
      billboard_position: index + 1,
      campaign_name: pageMetaStore.campaignName ?? '',
      page_path: useRoute().path,
    },
  })
}
</script>

<style lang="scss" scoped>
.billboard-container.multi {
  padding: 8px 4px;
}
</style>
